export function getActualViewData(state) {
  var _state$view$data;

  if (!((_state$view$data = state.view.data) !== null && _state$view$data !== void 0 && _state$view$data.headingType)) {
    return null;
  }

  return {
    data: {
      headingType: state.view.data.headingType
    }
  };
}